module.exports = __webpack_public_path__ + "static/media/gaelleLogoV2_Long_pour_fond_blanc.181b1f3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/gaelleLogoV2_Long_pour_fond_blanc.png
// module id = 1267
// module chunks = 0